import { Trans, useTranslation } from "react-i18next";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";

const JapanPrivateTourLogo = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/about/japan-private-tour-logo.png";
const JapanPrivateTourCorporateInformationImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/about/japan-private-tour-corporate-information.jpg";
const JapanPrivateTourContactImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/about/japan-private-tour-contact.jpg";
export const JapanPrivateTourDetail = () => {
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  return (
    <div className="tw:px-5 tw:lg:px-[82px] tw:mt-8 tw:lg:mt-[54px]">
      <div className="tw:bg-black tw:rounded-[10px] tw:px-[22px] tw:py-7 tw:lg:px-[54px] tw:lg:py-[54px] tw:flex tw:justify-between tw:items-start tw:lg:items-center">
        <div className="tw:lg:flex-1">
          <div className="tw:text-white tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:font-hanken-grotesk tw:leading-none tw:uppercase">
            {t("Corporate.Profile")}
          </div>
          <div className="tw:font-libre-caslon-display tw:text-white tw:text-[26px] tw:lg:text-[34px] tw:leading-[35px] tw:lg:leading-[45px] tw:mt-[10px] tw:lg:mt-3">
            {t("AboutPage.JapanPrivateTour.Title")}
          </div>
          <div className="tw:h-[1px] tw:bg-white tw:w-[88px] tw:my-4 tw:lg:my-7" />
          <div
            className={cn(
              "tw:text-white tw:font-hanken-grotesk",
              getTypographyClass(12),
              getTypographyClass(13, "lg")
            )}
          >
            <Trans
              className={cn(
                "tw:text-white tw:font-hanken-grotesk",
                getTypographyClass(12),
                getTypographyClass(13, "lg")
              )}
              i18nKey={`AboutPage.JapanPrivateTour.Description`}
              components={{
                strong: (
                  <strong></strong>
                ),
              }}
            />
          </div>
        </div>
        <div className="tw:lg:flex-1 tw:flex tw:items-start tw:lg:justify-end">
          <img
            src={JapanPrivateTourLogo}
            alt="logo"
            className="tw:min-w-[80px] tw:lg:min-w-[140px] tw:w-[80px] tw:lg:w-[140px]"
          />
        </div>
      </div>

      {/* Divider */}
      <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-8 tw:lg:my-[54px]" />

      {/* About */}
      <div className="tw:font-hanken-grotesk tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[354px]">
          {t("AboutPage.JapanPrivateTour.About.Label")}
        </div>
        <div
          className={cn(
            "tw:mt-5 tw:lg:mt-0",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          <Trans
            i18nKey={"AboutPage.JapanPrivateTour.About.Description"}
            components={{
              strong: <strong></strong>,
            }}
          />
        </div>
      </div>

      {/* Divider */}
      <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-8 tw:lg:my-[54px]" />

      {/* Corporate Information */}
      <div className="tw:font-hanken-grotesk tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[354px]">
          {t("AboutPage.JapanPrivateTour.CorporateInformation.Label")}
        </div>
        <div className="tw:flex tw:flex-col tw:xl:flex-row tw:flex-col-reverse tw:w-full tw:gap-x-[45px]">
          <div>
            <div className="tw:font-libre-caslon-display tw:mt-8 tw:xl:mt-0 tw:text-[22px] tw:lg:text-[26px] tw:leading-[26px] tw:lg:leading-[35px]">
              {t("AboutPage.JapanPrivateTour.CorporateInformation.CorporateName")}
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:mt-6 tw:lg:mt-8 tw:mb-6 tw:lg:mb-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.CorporateInformation.RegistrationNumber.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.CorporateInformation.RegistrationNumber.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.CorporateInformation.Services.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.CorporateInformation.Services.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.CorporateInformation.Address.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.CorporateInformation.Address.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.CorporateInformation.CEO.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.CorporateInformation.CEO.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.CorporateInformation.DateOfEstablishment.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.CorporateInformation.DateOfEstablishment.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.CorporateInformation.Capital.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.CorporateInformation.Capital.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="tw:flex tw:flex-1 tw:justify-center tw:2xl:justify-end tw:mt-5 tw:lg:mt-0">
            <img
              src={JapanPrivateTourCorporateInformationImage}
              alt="The Luxury Fleet Coporate Information"
              className="tw:h-[200px] tw:sm:h-[400px] tw:lg:h-full tw:lg:min-w-[260px] tw:w-full tw:xl:w-[260px] tw:object-cover tw:rounded-[5px] tw:object-bottom"
            />
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-8 tw:lg:my-[54px]" />

      {/* Contact */}
      <div className="tw:font-hanken-grotesk tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[354px]">
          {t("AboutPage.JapanPrivateTour.Contact.Label")}
        </div>
        <div className="tw:flex tw:gap-x-[45px] tw:gap-y-8 tw:flex-col tw:xl:flex-row tw:w-full tw:mt-5 tw:lg:mt-0">
          <div>
            <img
              src={JapanPrivateTourContactImage}
              alt="The Luxury Fleet Contact"
              className="tw:h-[200px] tw:sm:h-[400px] tw:lg:h-full tw:lg:min-w-[260px] tw:w-full tw:xl:w-[260px] tw:object-cover tw:rounded-[5px] tw:object-bottom"
            />
          </div>
          <div
            className={cn(
              "tw:mt-5 tw:lg:mt-0 tw:flex-1 tw:leading-[18.5px] tw:lg:leading-[20px]",
              getTypographyClass(13),
              getTypographyClass(14, "lg")
            )}
          >
            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.Contact.PhoneNumber.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.Contact.PhoneNumber.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.Contact.WhatsAppBusiness.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.Contact.WhatsAppBusiness.Value"}
                  components={{
                    u: <u></u>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.Contact.Email.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.Contact.Email.Value"}
                  components={{
                    u: <u></u>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.Contact.Website.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.Contact.Website.Value"}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.Contact.TripAdvisor.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.Contact.TripAdvisor.Value"}
                  components={{
                    u: <u></u>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.Contact.LINEOfficialAccount.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.Contact.LINEOfficialAccount.Value"}
                  components={{
                    u: <u></u>,
                  }}
                />
              </div>
            </div>

            {/* Divider */}
            <div className="tw:h-[1px] tw:bg-[#F1F1F1] tw:w-full tw:my-6 tw:lg:my-5" />

            <div className="tw:flex">
              <div
                className={cn(
                  "tw:min-w-[90px] tw:w-[90px] tw:mr-[45px] tw:lg:min-w-[195px] tw:lg:mr-0 tw:text-[#8D8D8D] tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("AboutPage.JapanPrivateTour.Contact.Instagram.Label")}
              </div>
              <div
                className={cn(
                  "tw:leading-[18.5px] tw:lg:leading-[20px]",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey={"AboutPage.JapanPrivateTour.Contact.Instagram.Value"}
                  components={{
                    u: <u></u>,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}